import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../../components/common/survey/form/SurveyForm';
import { SurveyInputContainer } from '../../../../../components/common/survey/inputs/SurveyInputContainer';
import { SurveyInputHeader } from '../../../../../components/common/survey/inputs/SurveyInputHeader';
import { RadioCard } from '../../../../../components/common/Radio/RadioCard';
import { joinProcessConstants } from '../../../../../constants/joinProcess';
import { useAppDispatch } from '../../../../../hooks/store/useStore';
import { userJoinSlice } from '../../../../../store/userJoinSlice';
import { JoinProcessPageWrapper } from '../JoinProcessPageWrapper';

export const JoinProcessTractorOwnCheckPage = () => {
  const navigate = useNavigate();

  const [ownTractorInfo, setOwnTractorInfo] = useState<string>();

  const dispatch = useAppDispatch();
  const userJoinActions = userJoinSlice.actions;

  const confirmHandler = () => {
    if (ownTractorInfo) {
      dispatch(userJoinActions.changeTractorOwnCheck(ownTractorInfo));
    }
    navigate('/join-process/tractor-want-buy-check', { replace: true });
  };

  return (
    <>
      <JoinProcessPageWrapper headerTitle={'트랙터 보유 유무를 알려주세요'} canConfirm confirmHandler={confirmHandler}>
        <SurveyForm>
          <SurveyInputHeader inputTitle={'트랙터 보유 유무'} isOptional />

          <SurveyInputContainer gridColumns={1}>
            {joinProcessConstants.tractorOwnCheck.values.map((value, index) => (
              <RadioCard
                key={value}
                title={value}
                label={
                  joinProcessConstants.tractorOwnCheck.labels && joinProcessConstants.tractorOwnCheck.labels.length > 0
                    ? joinProcessConstants.tractorOwnCheck.labels[index]
                    : undefined
                }
                onClick={() => {
                  setOwnTractorInfo(value);
                }}
                isActive={ownTractorInfo === value}
              />
            ))}
          </SurveyInputContainer>
        </SurveyForm>
      </JoinProcessPageWrapper>
    </>
  );
};
